@if (data.panel === 'Client') {
  @if (step === 1) {
    <div class="dialog-container">
      <button mat-icon-button class="close-btn" aria-label="Close" (click)="onClose(false)">
        <mat-icon>close</mat-icon>
      </button>
      <div class="icon-wrap">
        <mat-icon class="rotate-icon" fontIcon="autorenew"></mat-icon>
      </div>
      <h3 class="title">Are you sure you want to send for approval request?</h3>
      <div class="actions">
        <button class="confirm-btn" (click)="onConfirm()">Yes</button>
        <button class="cancel-btn" (click)="onClose(false)">Cancel</button>
      </div>
    </div>
  }
  @if (step === 2) {
    <div class="dialog-container success">
      <button mat-icon-button class="close-btn" aria-label="Close" (click)="onClose(true)">
        <mat-icon>close</mat-icon>
      </button>
      <div class="icon-wrap">
        <mat-icon class="mail-icon" fontIcon="mail"></mat-icon>
      </div>
      <h3 class="success-title">Thank you !</h3>
      <p class="subtitle">Approval request has been sent to the coordinator</p>
      <div class="actions only">
        <button class="confirm-btn" (click)="onClose(true)">OK</button>
      </div>
    </div>
  }
}
@if (data.panel === 'Coordinator') {
  @if (step === 1) {
    <div class="dialog-container">
      <button mat-icon-button class="close-btn" aria-label="Close" (click)="onClose({result:'CANCEL'})">
        <mat-icon>close</mat-icon>
      </button>
      <div class="icon-wrap">
        <mat-icon class="rotate-icon" fontIcon="autorenew"></mat-icon>
      </div>
      <h3 class="title">Are you sure you want to send for approval request?</h3>
      <div class="actions">
        <button class="confirm-btn" (click)="onConfirm()">Yes, Approve</button>
        <button class="cancel-btn" (click)="onClose({result:'REJECT'})">Reject</button>
        <button class="cancel-btn" (click)="onClose({result:'CANCEL'})">Cancel</button>
      </div>
    </div>
  }
  @if (step === 2) {
    <div class="dialog-container success">
      <button mat-icon-button class="close-btn" aria-label="Close" (click)="onClose({result:'APPROVE'})">
        <mat-icon>close</mat-icon>
      </button>
      <div class="icon-wrap">
        <mat-icon class="mail-icon" fontIcon="check"></mat-icon>
      </div>
      <h3 class="success-title">Thank you !</h3>
      <p class="subtitle">Impact summary is now approved</p>
      <div class="actions only">
        <button class="confirm-btn" (click)="onClose({result:'APPROVE'})">OK</button>
      </div>
    </div>
  }
}